import {
  EDITOR_TO_RENDERER_MESSAGE_TYPES,
  RENDERER_TO_EDITOR_MESSAGE_TYPES,
} from "./generated/renderer-bridge.discriminators.ts";
import type { components } from "./generated/renderer-bridge.ts";

export { EDITOR_TO_RENDERER_MESSAGE_TYPES, RENDERER_TO_EDITOR_MESSAGE_TYPES };

export type BridgeSchemas = components["schemas"];
export type BridgeSchema<N extends keyof BridgeSchemas> = BridgeSchemas[N];

export type EditorToRendererMessage = BridgeSchemas["EditorToRendererMessage"];
export type RendererToEditorMessage = BridgeSchemas["RendererToEditorMessage"];
export type BridgeMessage = EditorToRendererMessage | RendererToEditorMessage;

export type EditorToRendererMessageType = EditorToRendererMessage["type"];
export type RendererToEditorMessageType = RendererToEditorMessage["type"];
export type BridgeMessageType = BridgeMessage["type"];

export type MessageOf<T extends BridgeMessageType> = Extract<BridgeMessage, { type: T }>;

const editorToRenderer: ReadonlySet<string> = new Set(EDITOR_TO_RENDERER_MESSAGE_TYPES);
const rendererToEditor: ReadonlySet<string> = new Set(RENDERER_TO_EDITOR_MESSAGE_TYPES);

export function isEditorToRendererMessageType(value: unknown): value is EditorToRendererMessageType {
  return typeof value === "string" && editorToRenderer.has(value);
}

export function isRendererToEditorMessageType(value: unknown): value is RendererToEditorMessageType {
  return typeof value === "string" && rendererToEditor.has(value);
}
